import { ProposalIconType } from '../../../types/type';
import { GetProposalData } from '../../../api/gms/proposal/proposal-api-state';
import TableLoading from '../../ui/table-loading';
import TableError from '../../ui/table-error';
import TableEmpty from '../../ui/table-empty';
import { getStatusStyle } from '../proposal-status/proposal-list-tbody';

interface Props {
    typeOfIcon: ProposalIconType
    isLoadingGetProposal: boolean;
    isErrorGetProposal: boolean;
    errorMessage: string;
    spinnerColor?: string;
    spinnerSize?: number;
    getProposal: GetProposalData[] | undefined;
    handleEdit: (id: number, secName: string, preparedName: string) => void;
}

export default function ProposalExtensionTBody({ typeOfIcon, isLoadingGetProposal, isErrorGetProposal, errorMessage, spinnerColor = '#186cb2', spinnerSize = 25, getProposal, handleEdit }: Props) {
    
    return (
        <tbody className="divide-y divide-gray-100">
            {isLoadingGetProposal ? (
                <TableLoading />
            ) : isErrorGetProposal ? (
                <TableError description={errorMessage}/>
            ) : !getProposal || getProposal.length === 0 ? (
                <TableEmpty />
            ) : (
                getProposal?.map((proposal, index) => (
                    <tr
                        onClick={() => handleEdit(proposal.application_id, proposal.group_name, proposal.user_full_name)} 
                        key={proposal.application_id} 
                        className={`group cursor-pointer border-b border-gray-100 text-xs transition-colors duration-150 hover:bg-[#186cb2]/5 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50/60'}`}
                    >
                        <td className={`px-3 py-1 sm:px-4`}>
                            <span className={`inline-flex truncate rounded-full border px-2.5 py-1 text-[10px] font-semibold capitalize sm:text-[11px] ${getStatusStyle(proposal.status.name)}`}>
                                {proposal.status.name}
                            </span>
                        </td>
                        <td className="px-3 py-3 text-gray-700 sm:px-4">
                            <span className=" truncate text-gray-800" title={proposal.group_name}>
                                {proposal.group_name}
                            </span>
                        </td>
                        <td className="px-3 py-3 text-gray-700 sm:px-4">
                            <span className=" truncate" title={proposal.email}>
                            {proposal.email}
                            </span>
                        </td>
                        <td className="px-3 py-3 text-gray-700 sm:px-4">
                            <span className=" truncate" title={proposal?.type_of_proposal?.name}>
                                {proposal?.type_of_proposal?.name}
                            </span>
                        </td>
                        <td className="px-3 py-3 text-gray-700 sm:px-4">
                            <span className=" truncate" title={proposal?.plan?.name ?? proposal?.prototype_plan?.name}>
                                {proposal?.plan?.name || proposal?.prototype_plan?.name}
                            </span>
                        </td>
                        <td className="px-3 py-3 text-gray-700 sm:px-4">
                            <span className=" truncate" title={proposal.user_full_name}>
                                {proposal.user_full_name}
                            </span>
                        </td>
                    </tr>
                ))
            )}
        </tbody>
    )
}